import React from "react";
import { MainLayout } from "../../../components";
import { connect } from "react-redux";
import { logout } from "../../../redux/actions/login";
import { handleMainTab } from "../../../redux/actions/premium/homeActions";
import HomePage from "./home";
import { LocalStorageService } from "../../../services";
import { useSelector } from "react-redux";
// get step data from redux main state
const homeData = (state) => state.home;

function HomeLayout(props) {
  const data = useSelector(homeData);

  let currentStep = data && data.step;

  if (window.performance) {
    if (performance.navigation.type === 1) {
      LocalStorageService.remove("step1");
      LocalStorageService.remove("step2");
      LocalStorageService.remove("step3");
      LocalStorageService.remove("step4");
      LocalStorageService.remove("bucketName");
    } else {
    }
  }
  return (
    <MainLayout
      gameCompletion={
        currentStep === 2
          ? 25
          : currentStep === 3
          ? 50
          : currentStep === 4
          ? 75
          : currentStep === 5
          ? 100
          : null
      }
      showProgress={currentStep <= 5 ? true : false}
      logout={props.logout}
      stepHandler={props.handleMainTab}
    >
      <HomePage />
    </MainLayout>
  );
}
const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, { logout, handleMainTab })(HomeLayout);
